module.exports = __webpack_public_path__ + "img/ic_pdf_grey.53ed7012.svg";